"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFieldsetRow = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../../helpers");
const constants_1 = require("../../helpers/constants");
exports.StyledFieldsetRow = styled_components_1.default.tr `
    & > td {
        padding: 0 ${helpers_1.SPACING_XL} ${helpers_1.SPACING_S} 0;
        font-weight: ${helpers_1.BASE_FONT_NORMAL_WEIGHT};
        line-height: ${helpers_1.FONT_LINE_HEIGHT_M};
        vertical-align: top;
        ${({ wordBreak }) => (0, styled_components_1.css) `
            word-break: ${wordBreak};
        `}

        &:first-child {
            padding-left: ${helpers_1.SPACING_S};
            width: ${({ labelWidth }) => (labelWidth === 'auto' ? '1%' : labelWidth)};
            white-space: ${({ labelWidth }) => labelWidth === 'auto' ? 'nowrap' : 'normalGridRow'};
        }

        &:last-child {
            padding-right: ${helpers_1.SPACING_S};
        }
    }

    &:last-child > td {
        padding-bottom: ${constants_1.stylesConfig.paddingBottomLastTd};
    }
`;
//# sourceMappingURL=FieldsetRow.styles.js.map